import React, { useState } from "react";
import {
  Card,
  IconButton,
  Paper,
  Table,
  TableContainer,
  TableHead,
  TableRow,
  TableCell,
} from "@material-ui/core";
import { Delete, Edit } from "@material-ui/icons";
import { useDispatch } from "react-redux";
import { startLoading, stopLoading } from "../../../../actions/loadingAction";
import { useNavigate } from "react-router";
import AjaxHelper from "../../../../apis/apiRequest";
import { Endpoint, Status } from "../../../../apis/apiConstants";
import {
  errorSnackbar,
  successSnackbar,
} from "../../../../actions/snackbarActions";
import { setResponsiveDialog } from "../../../../reducers/responsiveDialogReducer";
import {
  DrawerItemsKey,
  ResponsiveDialogActions,
} from "../../../../constants/appConstants";
import utilsHelper from "../../../../helpers/utils.helper";
import "./story.component.scss";

export default function StoryComponent(props) {
  //   const [relationApproval, setRelationApprovals] = useState(mockApprovals);
  const [approvals, setApprovals] = useState([]);

  const navigate = useNavigate();

  const dispatch = useDispatch();

  React.useEffect(() => {
    if (props.approvalType === "Stories") {
      getAllApprovals(1, "");
    }
  }, [props.approvalType]);

  const getAllApprovals = (page, search) => {
    dispatch(startLoading);
    AjaxHelper.getApi(navigate, Endpoint.GET_STORIES_SELF, {}, { page, search })
      .then((response) => {
        console.log(response, "approvals response");
        dispatch(stopLoading);
        if (response.data.status === Status.API_SUCCESS) {
          setApprovals(response.data.data);
        } else if (response.data.status === Status.API_NO_CONTENT) {
          setApprovals([]);
          dispatch(errorSnackbar(response.data.message));
        } else {
          dispatch(errorSnackbar(response.data.message));
        }
      })
      .catch((error) => {
        dispatch(errorSnackbar("Error while fetching family approvals."));
      });
  };

  const deleteStory = (id) => {
    AjaxHelper.postApi(navigate, `${Endpoint.DELETE_STORY}/${id}`)
      .then((response) => {
        dispatch(stopLoading);
        if (response.data.status === Status.API_SUCCESS) {
          getAllApprovals();
          dispatch(successSnackbar("Story deleted."));
        } else {
          dispatch(errorSnackbar("Error while deleting the story"));
        }
      })
      .catch((err) => {
        dispatch(stopLoading);
        dispatch(errorSnackbar("Error while deleting the story"));
      });
  };

  return (
    <Card className="innerCard mt-3" variant="outlined">
      <TableContainer component={Paper}>
        <Table aria-label="simple table">
          <TableHead>
            <TableRow className={"background-color-head"}>
              <TableCell>
                <span className={"font-bold font-18"}>Headline</span>
              </TableCell>
              <TableCell>
                <span className={"font-bold font-18"}>Short description</span>
              </TableCell>
              <TableCell>
                <span className={"font-bold font-18"}>Status</span>
              </TableCell>
              <TableCell align="center">
                <span className={"font-bold font-18"}>Actions</span>
              </TableCell>
            </TableRow>
          </TableHead>

          {approvals.map((approval) => (
            <TableRow key={approval.id}>
              <TableCell>{approval.headline}</TableCell>
              <TableCell>{approval.shortDescription}</TableCell>
              <TableCell>{approval.status.capitalize()}</TableCell>
              <TableCell align="center">
                {approval.status === "pending" ? (
                  <IconButton
                    onClick={() =>
                      props.onPageChange(DrawerItemsKey.UPDATE_STORY_SCREEN, {
                        _id: approval._id,
                      })
                    }
                  >
                    <Edit color="primary" />
                  </IconButton>
                ) : null}

                <IconButton
                  onClick={() => {
                    dispatch(
                      setResponsiveDialog(
                        true,
                        "Delete",
                        "Do you want to delete the story?",
                        "Delete",
                        "Cancel",
                        (action) => {
                          if (action === ResponsiveDialogActions.POSITIVE) {
                            deleteStory(approval._id);
                          }
                        }
                      )
                    );
                  }}
                >
                  <Delete color={"error"} />
                </IconButton>
              </TableCell>
            </TableRow>
          ))}
        </Table>
      </TableContainer>
    </Card>
  );
}
